import { ComponentTheme } from "hardcover-ui/types/base";
import classNames from "lib/classNames";

export type ModalThemeProps = {
  variant: "primary";
  size: "xs" | "sm";
};

const modalClass = classNames(
  "w-full h-screen transform overflow-hidden text-left align-middle transition-all bg-background",
  "lg:rounded-xl lg:shadow-xl lg:border lg:border-secondary lg:h-auto",
);

export const modalTheme: ComponentTheme<ModalThemeProps> = {
  variant: {
    primary: `${modalClass} mx-auto`,
  },
  size: {
    xs: "lg:max-w-xl",
    sm: "lg:max-w-3xl",
  },
};
